import { connect } from '../../../common/react-redux';
import { createBank } from '../../api/banks';
import { createBankEntry, updateBankEntry, moveBankEntry, copyBankEntry } from '../../api/bankEntries';
import CopyMoveBankModal from './presenter';
import * as modalActions from '../../../common/actions/modal';
import { disassociateEntry } from '../../../common/actions/banks';
import * as uiActions from '../../../common/actions/ui';
import { COPY_MOVE_BANK_ENTRY_MODAL_KEEP_COPY, COPY_MOVE_BANK_ENTRY_MODAL } from '@instructure/quiz-common';
import { getModalTrigger } from '../../../common/util/modalHelpers';
export function mapStateToProps(state, props) {
  var modalKey = [COPY_MOVE_BANK_ENTRY_MODAL, props.entryType, props.entryId].join(':');
  return {
    modalTrigger: getModalTrigger(state),
    keepCopy: state.getIn(['ui', COPY_MOVE_BANK_ENTRY_MODAL_KEEP_COPY], true),
    modalOpen: state.getIn(['modal', 'isOpen']) === modalKey
  };
}
var mapDispatchToProps = {
  closeModal: modalActions.closeModal,
  createBank: createBank,
  copyBankEntry: copyBankEntry,
  createBankEntry: createBankEntry,
  updateBankEntry: updateBankEntry,
  moveBankEntry: moveBankEntry,
  disassociateBankEntry: disassociateEntry,
  uiSet: uiActions.set
};
export default connect(mapStateToProps, mapDispatchToProps)(CopyMoveBankModal);